import type { ComponentProps } from 'react';
import { TextEffectTwo } from 'react-text-animate';

export const TextBlurFadeEffect = (props: ComponentProps<typeof TextEffectTwo>) => {
  return <TextEffectTwo animateOnce {...props} className="react-text-animate" />;
};
